export default {"src":"/_next/static/media/DOCUMENT_DISABLED.69818113.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};